var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","background-color":"white"}},[_c('van-image',{attrs:{"src":require('@/assets/common/payment_complated.png'),"width":"30%","height":"20%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }